
















































































































































































































































































import { Vue, Watch, Component, Provide } from "vue-property-decorator";
import { API_BIS_CATEGORY, API_BIS_CATEGORY_TREE, API_BIS_FILTER, API_BIS_FILTER_TREE, API_BIS_LISTLAYOUT, API_BIS_PATENT_BATCHDELETE, API_BIS_PATENT_LIST, API_BIS_PATENT_TREE, API_BIS_PATENTTEXT } from "@/configs/Apis";
import { DEFAULT_DATE_FIELDS, DEFAULT_DATE_QUERY_TYPES, DEFAULT_TEXT_FIELDS, DEFAULT_DATE_PICKER_OPTIONS } from "@/app-data/patent-query";
import colFormatters from "@/utils/ColumnFormater";
import { showConfirm, showSuccess, showWarning } from "@/utils/UI";
import { isEmpty, isEmptyOrWhiteSpace, trim } from "@/utils/Common";

import ProjectImport from "../project/ProjectImport.vue";
import AdvSearch from "@/views/base/AdvSearch.vue";
import CustomField from "@/views/patent/CustomField.vue";
import DataClean from "@/views/patent/DataClean.vue";
import BatchIndex from "@/views/patent/BatchIndex.vue";
import PatentView from "@/views/patent/PatentView.vue";
import AdvSearchDialog from "@/views/patent/AdvSearchDialog.vue";
import BatchCategory from "@/views/patent/BatchCategory.vue";
import Ipc from "@/views/base/Ipc.vue";
import { FieldEntity, FieldQueryType, CondObject, CondItem } from "@/types";
import { CondOperator } from "@/app-data/enum";

@Component({
  components: { BatchCategory, AdvSearchDialog, AdvSearch, PatentView, BatchIndex, DataClean, ProjectImport, CustomField, Ipc }
})
export default class PatentList extends Vue {
  patentData: Array<any> = [];

  condition = {
    dateField: "", dateQueryType: "", keyWord: "", textField: "", dateQueryRange: [], dateQueryYear: null
  };

  showColumnConfigDialog = false;
  showPatentDetailFloater = false;

  pageSize = 20;
  pageIndex = 1;
  recordCount = 0;

  selectedItems: Nullable<Array<any>> = null;

  categoryTreeData: Array<any> = [];
  customFilterTreeData: Array<any> = [];
  navTreeData: Array<any> = [];

  defaultProps = {
    children: "children",
    label: "title"
  };

  queryStr: string = JSON.stringify({ items: [], relation: "" });

  advQueryStr = "";
  categoryQueryStr = "";

  nodecondition = "";

  queryMode: "standard" | "adv" | "category" = "standard";

  orderProp = "";
  currentItem: any = {};

  showProjectImportWin = false;
  showMetaDataWin = false;
  showDataCleanWin = false;
  showBatchIndexWin = false;
  showAdvSearchWin = false;
  showCustomFilterWin = false;
  showCategoryWin = false;
  showBatchCategoryWin = false;

  currentCustomFilter = { id: "", name: "", filterCondition: "", markPublic: false };
  currentCategory = { id: "", name: "", parentId: "" };

  activeNames = ["1", "2"];

  defaultExpandNodes: Array<number> = [];
  expandNodesMap: Set<number> = new Set<number>();

  @Provide()
  get projectId() {
    const pInfo: any = this.$store.state.project.info || {};
    return pInfo.id || 0;
  }

  created() {
    this.loadPatentList();
    this.loadNavTree();
    this.loadCategoryTree();
    this.loadCustomFilterTree();
  }

  get columns() {
    const columns: Array<any> = JSON.parse(this.$store.state.project.listLayout || "[]");
    if (!columns.length) {
      columns.push({ prop: "--unkown--", label: "" });
    }
    columns.filter(col => col.prop === "patentNo").forEach(col => {
      col.clickable = true;
    });
    return columns;
  }

  get configedColumns() {
    return JSON.parse(this.$store.state.project.listLayout).filter((col: any) => col.hidden !== true);
  }

  get hiddenColumns() {
    return JSON.parse(this.$store.state.project.listLayout).filter((col: any) => col.hidden === true);
  }

  get dateFields(): Array<FieldEntity> {
    return DEFAULT_DATE_FIELDS;
  }

  get dateQueryTypes(): Array<FieldQueryType> {
    return DEFAULT_DATE_QUERY_TYPES;
  }

  get textFields(): Array<FieldEntity> {
    return JSON.parse(JSON.stringify(DEFAULT_TEXT_FIELDS));
  }

  get datePickerOptions(): any {
    return DEFAULT_DATE_PICKER_OPTIONS;
  }

  get customFilterRules() {
    return {
      name: [
        { required: true, message: "请输入筛选器名称", trigger: "blur" }
      ]
    };
  }

  navToReport() {
    this.$router.push({ path: "/report", query: { id: this.projectId } });
  }

  importData() {
    this.showProjectImportWin = true;
  }

  onColumnConfig() {
    this.showColumnConfigDialog = true;
  }

  onColumnWidthChange(newWidth: number, oldWidth: number, column: any) {
    const columns: Array<any> = JSON.parse(this.$store.state.project.listLayout);
    columns.filter(col => col.prop === column.property).forEach(col => {
      col.width = newWidth;
    });
    const layout = JSON.stringify(columns);
    this.$store.commit("project/listLayout", layout);
    this.$http.post(API_BIS_LISTLAYOUT, { listName: "PATENT", layout: layout, projectId: this.projectId }, false);
  }

  saveColumnConfig() {
    const selector = (this.$refs.colSelector as any);
    const hiddenItems: Array<any> = selector.getSelectedItems();
    const allColumns: Array<any> = selector.getListData();

    if (hiddenItems && hiddenItems.length) {
      hiddenItems.forEach(col => {
        col.hidden = true;
      });
    }

    allColumns.forEach(col => {
      col.hidden = false;
    });
    const newListLayout = JSON.stringify(allColumns.concat(hiddenItems));
    return this.$http.post(API_BIS_LISTLAYOUT, { listName: "PATENT", layout: newListLayout, projectId: this.projectId }).then(() => {
      showSuccess("保存成功");
      this.showColumnConfigDialog = false;
      this.$store.dispatch("project/setListLayout", { id: this.projectId }).then(() => (this.$refs.dataTable as any).doLayout());
    });
  }

  loadNavTree() {
    this.$http.get<Array<any>>({ url: API_BIS_PATENT_TREE, path: { projectId: this.projectId } }, {}, false).then((data) => {
      this.navTreeData = [{ title: "全部", patentFilter: { filterCondition: "" } }].concat(data);
    });
  }

  loadCustomFilterTree() {
    this.$http.get<Array<any>>({ url: API_BIS_FILTER_TREE, path: { projectId: this.projectId } }, {}, false).then((data) => {
      this.customFilterTreeData = data;
    });
  }

  loadCategoryTree() {
    this.$http.get<Array<any>>({ url: API_BIS_CATEGORY_TREE, path: { projectId: this.projectId } }, {}, false).then((data) => {
      const treeData: Array<any> = [];
      const map = new Map<string, any>();
      if (data && data.length) {
        data.forEach(item => {
          if (item.treeLevel === 0) {
            return;
          }

          let treeItem;
          if (map.has(item.id)) {
            treeItem = map.get(item.id);
            if (isEmptyOrWhiteSpace(treeItem.title)) {
              Object.assign(treeItem, item);
            }
          } else {
            treeItem = { name: item.name, ...item };
            map.set(item.id, treeItem);
          }

          if (item.treeLevel === 1) {
            treeData.push(treeItem);
          } else {
            const pId = item.parentId;
            if (map.has(pId)) {
              const pItem = map.get(pId);
              if (!Object.prototype.hasOwnProperty.call(pItem, "children")) {
                pItem.children = [];
              }
              pItem.children.push(treeItem);
            } else {
              map.set(pId, { children: [treeItem] });
            }
          }
        });
      }
      if (this.expandNodesMap.size) {
        this.expandNodesMap.forEach(value => this.defaultExpandNodes.push(value));
      }
      this.categoryTreeData = treeData;
    });
  }

  onNodeClick(node: any) {
    if (!Object.prototype.hasOwnProperty.call(node, "patentFilter")) {
      return;
    }
    this.nodecondition = node.patentFilter.filterCondition;
    this.onSearchConditionChange();
  }

  onCategoryNodeClick(data: any, node: any) {
    this.queryMode = "category";
    const condObj: CondObject = { items: [], relation: "1" };
    if (node.level > 1) {
      // 查找顶级节点
      let root = node;
      while ((node = root.parent) && node.level >= 1) {
        root = node;
      }
      condObj.items.push({ name: `category${root.data.id}`, value1: data.id, value2: "", operator: CondOperator.IN });
    }
    this.categoryQueryStr = JSON.stringify(condObj);
    this.loadPatentList();
  }

  onCategoryNodeExpand(data: any) {
    this.expandNodesMap.add(data.id);
  }

  onCategoryNodeCollapse(data: any) {
    this.expandNodesMap.delete(data.id);
  }

  onFilterNodeClick(node: any) {
    this.advSearchData(node.patentFilter.filterCondition);
  }

  loadPatentList() {
    let queryStr: string;
    switch (this.queryMode) {
      case "adv":
        queryStr = trim(this.advQueryStr);
        break;
      case "category":
        queryStr = trim(this.categoryQueryStr);
        break;
      case "standard":
      default:
        queryStr = trim(this.queryStr);
        break;
    }
    const condObject = {
      condition: queryStr,
      page: this.pageIndex - 1,
      pageSize: this.pageSize,
      orderBy: ""
    };
    if (!isEmpty(this.orderProp)) {
      condObject.orderBy = this.orderProp;
    }
    this.$http.post<{ count: number, data: Array<any> }>({ url: API_BIS_PATENT_LIST, path: { projectId: this.projectId } }, condObject).then(({ count, data }) => {
      this.recordCount = count;
      this.patentData = data;
    });
  }

  onSelectionChanged(items: Array<any>) {
    this.selectedItems = items;
  }

  getFormatters(prop: string) {
    if (isEmptyOrWhiteSpace(prop)) {
      return null;
    }
    const chars = prop.split("");
    chars[0] = chars[0].toUpperCase();
    const formatKey = `format${chars.join("")}`;
    return colFormatters[formatKey] || function (data: any, column: any, value: any) {
      return value;
    };
  }

  onDataCommand(command: string, row: any, event: MouseEvent) {
    event.stopPropagation();
    this.currentItem = row;
    (this.$refs.dataTable as any).setCurrentRow(row);
    if (command === "patentNo") {
      this.showPatentDetailFloater = true;
    }
  }

  onBatchOpCommand(command: string) {
    if (command === "delete") {
      this.deletePatent();
    } else if (command === "patenttext") {
      this.updatePatentText();
    } else if (command === "clean") {
      this.showDataCleanWin = true;
    } else if (command === "indexing") {
      this.batchIndexing();
    } else if (command === "category") {
      this.batchCategory();
    }
  }

  deletePatent() {
    if (!this.selectedItems || !this.selectedItems.length) {
      return showWarning("请选择要删除的专利");
    }
    showConfirm("是否删除选择的专利").then(() => {
      const projectId = this.$store.state.project.info.id;
      this.$http.post({ url: API_BIS_PATENT_BATCHDELETE, path: { projectId } }, this.selectedItems!.map(item => item.id)).then(() => {
        showSuccess("删除成功");
        this.loadPatentList();
      });
    });
  }

  batchIndexing() {
    if (!this.selectedItems || !this.selectedItems.length) {
      return showWarning("请选择要标引的专利");
    }
    this.showBatchIndexWin = true;
  }

  batchCategory() {
    if (!this.selectedItems || !this.selectedItems.length) {
      return showWarning("请选择要分类的专利");
    }
    this.showBatchCategoryWin = true;
  }

  onDateQueryChange() {
    this.onSearchConditionChange();
  }

  onTextKeyup() {
    this.onSearchConditionChange();
  }

  searchData() {
    (this.$refs.dataTable as any).clearSelection();
    if (this.queryStr.endsWith(" ")) {
      this.queryStr = trim(this.queryStr);
    } else {
      this.queryStr += " ";
    }
  }

  advSearchData(advCondStr: string) {
    this.advQueryStr = advCondStr;
    this.queryMode = "adv";
    (this.$refs.dataTable as any).clearSelection();
    this.onPagePropertyChange();
  }

  onSortChange({ prop, order }: any) {
    const field: string = prop;
    if (isEmpty(order)) {
      this.orderProp = "";
    } else {
      /*            if (/^(varchar|enum|text)\d+$/g.test(field)) {
                      field = field.replace(/\d+$/g, (value) => `_${value}`);
                  } */
      this.orderProp = `${field} ${order.replace("ending", "")}`;
    }
  }

  closeImportDialog(status: string) {
    if (status === "COMPLETED") {
      this.$store.dispatch("project/setCustomField", this.$store.state.project.info);
      this.searchData();
    }
  }

  setMetaData() {
    this.showMetaDataWin = true;
  }

  reloadListLayout() {
    this.$store.dispatch("project/setListLayout", { id: this.projectId });
  }

  updatePatentText() {
    const task = this.$store.state.synctask.patentTextTask;
    if (task.status === "RUNNING") {
      showWarning("有一个正在执行的任务，请等待任务完成后再更新");
      return;
    }
    showConfirm("是否更新代码化全文/法律状态").then(() => {
      this.$http.post(API_BIS_PATENTTEXT, { projectId: this.projectId }).then((taskId) => {
        showSuccess("数据更新任务已提交到后台");
        return this.$store.dispatch("synctask/progressPatentText", { taskId: taskId, projectId: this.projectId });
      });
    });
  }

  onBodyClick(e: MouseEvent) {
    if (e) {
      e.stopPropagation();
    }
    this.showPatentDetailFloater = false;
  }

  openAdvSearch() {
    this.showAdvSearchWin = true;
  }

  deleteFilter(node: any, item: any, event: MouseEvent) {
    event.stopPropagation();
    const data = node.data;
    showConfirm("是否删除这个筛选器").then(() => {
      this.$http.delete({ url: API_BIS_FILTER, path: { projectId: this.projectId, id: data.nodeId } }, data.nodeId).then(() => {
        showSuccess("删除成功");
        this.loadCustomFilterTree();
      });
    });
  }

  editFilter(node: any, data: any, event: MouseEvent) {
    event.stopPropagation();
    this.showCustomFilterWin = true;
    this.currentCustomFilter = JSON.parse(JSON.stringify(data.patentFilter));
  }

  addFilter(event: MouseEvent) {
    event.stopPropagation();
    this.currentCustomFilter = { name: "", filterCondition: "", markPublic: false, id: "" };
    this.showCustomFilterWin = true;
  }

  saveCustomFilter() {
    (this.$refs.customFilterForm as any).validate((isValid: boolean) => {
      if (!isValid) {
        return;
      }
      const adv = this.$refs.advt as any;
      const filter = this.currentCustomFilter;
      let handler: (...args: any[]) => Promise<any>;
      if (!isEmptyOrWhiteSpace(filter.id)) {
        handler = this.$http.put;
      } else {
        handler = this.$http.post;
      }

      const newData: any = {};

      Object.assign(newData, { id: filter.id || 0, name: filter.name, filterCondition: adv.getSearchData(), markPublic: filter.markPublic });
      if (isEmptyOrWhiteSpace(newData.id)) {

      }
      handler.call(this.$http, { url: API_BIS_FILTER, path: { projectId: this.projectId, id: filter.id || "" } }, newData).then(() => {
        showSuccess("保存成功");
        this.loadCustomFilterTree();
        this.showCustomFilterWin = false;
      });
    });
  }

  addCategory(data: any, event: MouseEvent) {
    event.stopPropagation();
    this.currentCategory = { id: "", name: "", parentId: data.id };
    this.showCategoryWin = true;
  }

  editCategory(data: any, event: MouseEvent) {
    event.stopPropagation();
    this.currentCategory = JSON.parse(JSON.stringify(data));
    this.showCategoryWin = true;
  }

  deleteCategory(data: any, event: MouseEvent) {
    event.stopPropagation();
    showConfirm("是否删除这个分类").then(() => {
      this.$http.delete({ url: API_BIS_CATEGORY, path: { projectId: this.projectId, id: data.id } }, data.id).then(() => {
        showSuccess("删除成功");
        this.loadCategoryTree();
      });
    });
  }

  saveCategory() {
    (this.$refs.categoryForm as any).validate((isValid: boolean) => {
      if (!isValid) {
        return;
      }
      const url: any = { path: { projectId: this.projectId } };
      let handler: (...args: any[]) => Promise<any>;
      if (isEmptyOrWhiteSpace(this.currentCategory.id)) {
        url.url = API_BIS_CATEGORY;
        handler = this.$http.post;
      } else {
        url.url = `${API_BIS_CATEGORY}/${this.currentCategory.id}`;
        handler = this.$http.put;
      }
      const newData = {};
      const category = this.currentCategory;

      Object.assign(newData, { id: category.id || 0, name: category.name, parentId: category.parentId || 0 });

      handler.call(this.$http, url, newData).then(() => {
        showSuccess("保存成功");
        if (category.parentId) {
          this.expandNodesMap.add(Number(category.parentId));
        }
        this.loadCategoryTree();
        this.showCategoryWin = false;
      });
    });
  }

  loadPatentDataAndCategoryTree() {
    this.onPagePropertyChange();
    this.loadCategoryTree();
  }

  loadAllTree() {
    this.loadCategoryTree();
    this.loadCustomFilterTree();
  }

  @Watch("condition.dateField")
  @Watch("condition.textField")
  @Watch("condition.dateQueryType")
  onSearchConditionChange() {
    const condItems: Array<CondItem> = [];
    if (!isEmpty(this.condition.dateField) && !isEmpty(this.condition.dateQueryType)) {
      const condItem: CondItem = { name: this.condition.dateField, operator: CondOperator.BETWEEN, value1: "", value2: "" };

      if (this.condition.dateQueryType === "year" && this.condition.dateQueryYear) {
        const year = ((this.condition.dateQueryYear as any) as Date).getFullYear();
        switch (this.condition.dateField) {
          case "appDate":
          case "pubDate":
          case "authDate":
          case "modifiedTime":
            condItem.value1 = year + "-01-01";
            condItem.value2 = year + "-12-31";
            break;
          default:
            break;
        }
      } else if (this.condition.dateQueryType === "range" && this.condition.dateQueryRange && this.condition.dateQueryRange.length === 2) {
        switch (this.condition.dateField) {
          case "appDate":
          case "pubDate":
          case "authDate":
          case "modifiedTime":
            condItem.value1 = this.condition.dateQueryRange[0];
            condItem.value2 = this.condition.dateQueryRange[1];
            break;
          default:
            break;
        }
      }
      if (!isEmptyOrWhiteSpace(condItem.value1)) {
        condItems.push(condItem);
      }
    }

    if (!isEmpty(this.condition.textField) && !isEmpty(this.condition.keyWord)) {
      condItems.push({ name: this.condition.textField, operator: CondOperator.LIKE, value1: this.condition.keyWord, value2: "" });
    }

    if (!isEmpty(this.nodecondition)) {
      const nodeCondObject: CondObject = JSON.parse(this.nodecondition);
      if (nodeCondObject.items && nodeCondObject.items.length) {
        condItems.push(...nodeCondObject.items);
      }
    }

    const condObject: CondObject = { items: [], relation: "" };
    condObject.items = condItems;
    if (condItems.length) {
      const indexes: Array<number> = [];
      condItems.forEach((item, index) => indexes.push(index + 1));
      condObject.relation = indexes.join(" and ");
    }
    this.queryStr = JSON.stringify(condObject);
  }

  @Watch("queryStr")
  onQueryStrChanged() {
    this.queryMode = "standard";
    this.onPagePropertyChange();
  }

  @Watch("pageSize")
  @Watch("orderProp")
  onPagePropertyChange() {
    if (this.pageIndex === 1) {
      this.loadPatentList();
    } else {
      this.pageIndex = 1;
    }
  }

  @Watch("pageIndex")
  onPageIndexChange() {
    this.loadPatentList();
  }
};
